import { combineReducers } from 'redux';
import { scheduledQuotesBlotterReducer } from 'state/blotters/scheduledQuotes';
import { tradesBlottersReducer } from 'state/blotters/trades/tradesBlotters.reducer';

import type { BlottersState } from './blotter.model';
import { blotterPanelReducer } from './blotterPanel/blotterPanel.reducer';
import { dailyBlotterReducer } from './dailyBlotter/dailyBlotter.reducer';
import { priceImprovementBlotterReducer } from './priceImprovement';
import { quoteBlotterReducer } from './quote/quoteBlotter.reducer';
import { secondaryMarketOrderBlotterReducer } from './secondaryMarketOrderBlotter';
import { secondaryMarketTradeBlotterReducer } from './secondaryMarketTradeBlotter';

export const blottersReducer = combineReducers<BlottersState>({
  secondaryMarket: secondaryMarketTradeBlotterReducer,
  secondaryMarketOrder: secondaryMarketOrderBlotterReducer,
  quotes: quoteBlotterReducer,
  trades: tradesBlottersReducer,
  priceImprovement: priceImprovementBlotterReducer,
  blotterPanel: blotterPanelReducer,
  dailyBlotter: dailyBlotterReducer,
  scheduledQuotes: scheduledQuotesBlotterReducer,
});
